import { useQuery } from 'react-query';
import {
  getCastRelationships,
  type CastRelationshipsResponse
} from '../../services/castRelationshipService';

export function useGetCastRelationships({ page, perPage }: { page: number; perPage: number }) {
  return useQuery<CastRelationshipsResponse>(
    ['castRelationships'],
    () => getCastRelationships({ page, perPage }),
    {}
  );
}
